import storage from 'config/storage'
import { systemLang } from 'config/systemLang'
import { Languages } from 'interfaces/translations.interfaces'

export const getLang: () => Languages = () => storage.getLang() ?? systemLang
